import { CaptionsRadioGroupOptions, CaptionsRadioGroupRoot } from "../../../../../ui/captions-radio-group/component.js";
import { MenuContent } from "../../../../../ui/menu/content.js";
import { MenuPopup } from "../../../../../ui/menu/popup.js";
import { MenuRoot } from "../../../../../ui/menu/root.js";
import { MenuTrigger } from "../../../../../ui/menu/trigger.js";
import { ButtonTooltip } from "../../../shared/components/buttons/button-tooltip.js";
import { CaptionsButton } from "../buttons/captions-button.js";
import { RadioItem } from "./radio-item.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-video/components/menus/captions-menu.tsx
/** @jsxImportSource react */
function CaptionsMenu({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(MenuRoot, {
		side: "top",
		align: "center",
		boundary: "viewport",
		...props,
		children: /* @__PURE__ */ jsxs(CaptionsRadioGroupRoot, { children: [/* @__PURE__ */ jsx(ButtonTooltip, {
			side: "top",
			children: /* @__PURE__ */ jsx(MenuTrigger, {
				render: /* @__PURE__ */ jsx(CaptionsButton, {}),
				className
			})
		}), /* @__PURE__ */ jsx(MenuPopup, {
			className: cn("media-popup", "media-popup-surface", "media-menu-popup"),
			children: /* @__PURE__ */ jsx(MenuContent, {
				className: "media-menu-content",
				children: /* @__PURE__ */ jsx(CaptionsRadioGroupOptions, {
					className: "media-menu-radio-group",
					renderItem: (props, item) => /* @__PURE__ */ jsx(RadioItem, {
						...props,
						children: /* @__PURE__ */ jsx("span", { children: item.label })
					})
				})
			})
		})] })
	});
}
//#endregion
export { CaptionsMenu };

//# sourceMappingURL=captions-menu.js.map